<template>
    <section class="need-help">
        <div class="alert alert-primary d-flex">
            <router-link to="/24h-emergency"><span>24H EMERGENCY <br class="d-md-none"/>MEDICAL ASSISTANCE</span></router-link>
        </div>
    </section>
</template>

<script>
export default {
    
}
</script>